module.exports = __webpack_public_path__ + "static/media/grin-squint.57f3e2a9.svg";